module.exports = __webpack_public_path__ + "static/media/host_other.9b6d1f90.png";